import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { ensure } from '../../../../utils/EnsureState'
import { Pattern } from '../../../../utils/Regex'
import { MVPButton } from '../../../Buttons/MVPButton'
import { MVPTextInput } from '../../../TextInput/MVPTextInput'
import './FriendsTransferFundsModal.scss'

type FriendsTransferFundsModalFormData = {
	amount: string
}
export interface FriendsTransferFundsModalViewProps
{
	moneyAmount: string,

	isLoading: boolean,
	clickSubmit: (amount: string) => void
	clickClose: () => void
}

export const FriendsTransferFundsModalView : React.FC<FriendsTransferFundsModalViewProps> = ({ moneyAmount, isLoading, clickSubmit, clickClose }) =>
{
	const formHandler = useForm<FriendsTransferFundsModalFormData>()
	
	return (
		<>
			<span className='modal-title'>TRANSFER FUNDS</span>
			<FormProvider {...formHandler}>
				<form onSubmit={formHandler.handleSubmit((data) => { clickSubmit(`${data.amount}`)})}>
					<MVPTextInput
						label='Amount to transfer'
						formField='amount'
						formValidation={{
							validate: ensure()
								.required()
								.min(1, 'Transfer a minimum of $1!')
								.max(parseFloat(moneyAmount), `You can only transfer a maximum of $${moneyAmount}`)
								.pattern(Pattern.DecimalWithThousandsSeparator)
								.build(),
						}}
						placeholder='Amount'
						prefix='$'
					/>
					<p id='prompt'>This is an internal transfer and is instantenous.</p>
					<div id='buttons-container'>
						<MVPButton className='clear' onClick={clickClose}>
							Cancel
						</MVPButton>
						<MVPButton type='submit' loading={isLoading}>
							Transfer
						</MVPButton>
					</div>
				</form>
			</FormProvider>
		</>
	)
}
